var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-dialog',{attrs:{"value":_vm.value,"max-width":"290"},on:{"input":val => _vm.$emit('input', val)}},[_c('v-card',[_c('v-card-title',{staticClass:"headline",domProps:{"innerHTML":_vm._s(_vm.title)}}),_c('v-card-text',[_vm._t("text")],2),_c('v-card-actions',[_c('v-spacer'),_vm._t("actions")],2)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }